import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import Endpoints from "../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../base";
import { FetchServiceProviders } from "../../domain/useages/fetch-service-providers";
import { RemoteFetchServiceProviders } from "../../data/usecases/remote-fetch-service-providers";
import { ServiceProvider } from "../../domain/models/service-provider";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchServiceProviderInterface {
  serviceProvider: ServiceProvider[];
  fetchServiceProvider: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


const initialStates = {
  serviceProvider: [],
};

export const useFetchServiceProviderSlice: StateCreator<
  FetchServiceProviderInterface
> = (set, get) => ({
  ...initialStates,
  fetchServiceProvider: async () => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchServiceProviders: FetchServiceProviders =
      new RemoteFetchServiceProviders(
        `${BASE_URL}${Endpoints.FETCH_SERVICE_PROVIDER}`,
        axiosHttpClient
      );

    let result = await remoteFetchServiceProviders.get();
    if (result) {
      set({ serviceProvider: result.service_providers });
    }
  },
});
